import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'
import Checkmark from '../icons/Checkmark'
import { CheckmarkWrapper } from './Receipt'

const OutcomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const OutcomeHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
`

const OutcomeNote = styled.span`
  font-size: 14px;
  color: ${RADOM_COLORS.GRAY_DARKEST};
  text-align: center;
`

export const PaymentSuccessMessage = (): ReactElement => (
  <OutcomeWrapper>
    <OutcomeHeading>
      <CheckmarkWrapper>
        <Checkmark width={30} height={30} animationDelay='0.5s' animationSpeed='0.75s' />
      </CheckmarkWrapper>
      <span style={{ fontSize: 18, color: RADOM_COLORS.BLACK }}>Payment successful</span>
    </OutcomeHeading>
  </OutcomeWrapper>
)

export const PaymentUnderReviewMessage = (): ReactElement => (
  <OutcomeWrapper>
    <OutcomeHeading>
      <span style={{ fontSize: 18, color: RADOM_COLORS.BLACK }}>Payment under review</span>
    </OutcomeHeading>
    <OutcomeNote>
      We&apos;ve received your payment. It&apos;s going through a routine compliance check
      and will be released to the merchant once it clears.
    </OutcomeNote>
  </OutcomeWrapper>
)

export const PaymentConfirmingMessage = (): ReactElement => (
  <OutcomeWrapper>
    <OutcomeHeading>
      <span style={{ fontSize: 18, color: RADOM_COLORS.BLACK }}>Confirming your payment</span>
    </OutcomeHeading>
    <OutcomeNote>
      We&apos;ve received your transfer and are confirming it. This page updates automatically.
    </OutcomeNote>
  </OutcomeWrapper>
)
